import { SvgIcon } from '@progress/kendo-react-common';
import { useRef } from 'react';
import { ExtractKeysExtend } from '../../../../../../../components/helpers/helpers';
import { MonitorAircraftThresholdAlerts, MonitorAirportThresholdAlerts, MonitorThresholdAlert } from '../../../../../../../types/thresholds';
import { alertDefinitions } from './AlertEditView';
import React from 'react';
import clsx from 'clsx';

export type AlertClickArgs = {
    element: HTMLElement;
};

const airportDisplayAlerts: Array<ExtractKeysExtend<MonitorAirportThresholdAlerts, MonitorThresholdAlert>> = [
    'eventList',
    'email',
    'logFile',
    'osAlert',
    'popup',
    'overrideColor',
    'voice',
    'playSound'
];

const aircraftDisplayAlerts: Array<ExtractKeysExtend<MonitorAircraftThresholdAlerts, MonitorThresholdAlert>> = [
    'eventList',
    'email',
    'logFile',
    'osAlert',
    'popup',
    'zoomToAircraft',
    'aircraftTag',
    'overrideColor',
    'enableMarker',
    'voice',
    'playSound'
];

function makeAlertView<T extends MonitorAircraftThresholdAlerts | MonitorAirportThresholdAlerts>(
    displayList: T extends MonitorAircraftThresholdAlerts ? typeof aircraftDisplayAlerts : typeof airportDisplayAlerts
) {
    return React.memo((props: { alerts?: T; readonly: boolean; onClick?: (e: AlertClickArgs) => void }) => {
        const ref = useRef<HTMLDivElement>(null);
        const icons = displayList
            .filter((x) => (props.alerts?.[x as keyof typeof props.alerts] as MonitorThresholdAlert | undefined)?.value === true)
            .filter((k) => alertDefinitions[k].icon);

        return (
            <div
                className={clsx('d-flex gap-1 align-items-center', !props.readonly && 'fe-hover')}
                ref={ref}
                onClick={() => !props.readonly && props.onClick?.({ element: ref.current! })}>
                {icons.map((x) => (
                    <SvgIcon key={x} icon={alertDefinitions[x].icon!} />
                ))}
            </div>
        );
    });
}

export const AirportAlertCell = makeAlertView(airportDisplayAlerts);
export const AircraftAlertCell = makeAlertView(aircraftDisplayAlerts);
